import { render, staticRenderFns } from "./GraphDetail44.vue?vue&type=template&id=2d81195a&scoped=true"
import script from "./GraphDetail44.vue?vue&type=script&lang=js"
export * from "./GraphDetail44.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81195a",
  null
  
)

export default component.exports